
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1vtzr_eugv6_9",
  "view-button": "awsui_view-button_1vtzr_eugv6_13",
  "browse-button": "awsui_browse-button_1vtzr_eugv6_17",
  "layout": "awsui_layout_1vtzr_eugv6_21",
  "layout-uri": "awsui_layout-uri_1vtzr_eugv6_33",
  "layout-version": "awsui_layout-version_1vtzr_eugv6_37",
  "layout-divider": "awsui_layout-divider_1vtzr_eugv6_42"
};
  